import script from "./ClientAddWorkerDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientAddWorkerDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./ClientAddWorkerDropdown.vue?vue&type=style&index=0&id=56bc81df&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56bc81df"]])

export default __exports__